import { useState, useContext } from "react";

import Section from "../UI/Section";
import TodoForm from "./TodoForm";
import useHttp from "../hooks/use-http";
import AuthContext from "../../store/auth-context";

const NewTodo = (props) => {
  const { isLoading, error, sendRequest: sendTodoRequest } = useHttp();
  const authCtx = useContext(AuthContext);

  const createTodo = (todoText, todoData) => {
    // Spring Boot returns the created object with an 'id' property.
    // If we use Kafka, the ID might not be generated yet (Optimistic UI).
    // Fallback to a temporary random ID if missing.
    const generatedId = todoData.id || `temp-${Math.random().toString(36).substr(2, 9)}`;
    const createdTodo = {
      id: generatedId,
      text: todoText,
      createDate: todoData.createDate || new Date().toISOString()
    };

    props.onAddTodo(createdTodo);
  };

  const enterTodoHandler = async (todoText) => {
    sendTodoRequest(
      {
        url: "/todo",
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: { text: todoText },
      },
      createTodo.bind(null, todoText)
    );
  };

  return (
    <>
      {authCtx.userName && <h2 style={{ textAlign: "center", color: "white" }}>Hallo, {authCtx.userName}!</h2>}
      <Section>
        <TodoForm onEnterTodo={enterTodoHandler} loading={isLoading} />
        {error && <p>{error}</p>}
      </Section>
    </>
  );
};

export default NewTodo;
